import { Component, ElementRef, Input, Renderer2, ViewEncapsulation } from '@angular/core';
import { NavbarVerticalStyle1Component } from './vertical/style-1/style-1.component';

@Component({
  standalone: true,
  imports: [NavbarVerticalStyle1Component],
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent {
  _variant: string = 'vertical-style-1';

  constructor(
    private _elementRef: ElementRef,
    private _renderer: Renderer2
  ) {}

  get variant(): string {
    return this._variant;
  }

  @Input()
  set variant(value: string) {
    // Remove the old class name
    this._renderer.removeClass(this._elementRef.nativeElement, this.variant);

    // Store the variant value
    this._variant = value;

    // Add the new class name
    this._renderer.addClass(this._elementRef.nativeElement, value);
  }
}
